import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, UnreviewedSalesListboxInfo } from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class SaleApprovalService {
  private readonly sdk: ApiClient = inject(ApiClient);

  getUnreviewedSales(
    branchIds: string[],
    startDate?: Date,
    endDate?: Date
  ): Observable<UnreviewedSalesListboxInfo> {
    return this.sdk.getUnreviewedSales(branchIds, startDate, endDate);
  }
}
